<arm-layout [summaryTitle]="'FILE REPOSITORY SUMMARY'">
  <div header>
    <div class="search-container">
      <arm-search (onSearch)="onSearch($event)"></arm-search>
    </div>

    <div class="action-buttons">

      <arm-action-bar (addClick)="addItem()" [disableAdd]="isUnauthorized"
                      (editClick)="editItem()" [disableEdit]="isUnauthorized || !selection"
                      (deleteClick)="removeItem()" [disableDelete]="isUnauthorized || !selection"
                      (refreshClick)="refresh()"></arm-action-bar>

      <button [matMenuTriggerFor]="menu" class="more-actions" color="primary" mat-raised-button>
        <span>Actions</span>
        <mat-icon>arrow_drop_down</mat-icon>
      </button>

      <mat-menu #menu="matMenu">
        <button (click)="openColumnsConfiguration()" mat-menu-item>
          <span>Table columns</span>
        </button>
      </mat-menu>
    </div>
  </div>

  <div summary>
    <file-repository-summary [selection]="selection" [normalizationGroups]="normalizationGroups">
    </file-repository-summary>
  </div>

  <div main>
    <arm-table [data]="data.elements" (onSelection)="select($event)" [length]="data.totalElements"
               [displayedColumns]="displayedColumns" [isMultipleSelection]="false"
               [isClientSide]="false"
               (pageChanged)="pageChanged($event)"></arm-table>
  </div>
</arm-layout>
